import BaseApiService from './BaseApiService.js';

class VehicleService extends BaseApiService {
  // ✅ Create new vehicle
  async createVehicle(vehicleData) {
    return this.makeRequest('/api/admin/vehicle/create', {
      method: 'POST',
      body: JSON.stringify(vehicleData),
    });
  }

  // ✅ List all vehicles
  async listVehicles() {
    return this.makeRequest('/api/admin/vehicle/list');
  }

  // ✅ Get vehicle details
  async getVehicleDetails(vehicleId) {
    return this.makeRequest(`/api/admin/vehicle/${vehicleId}`);
  }

  // ✅ Update vehicle
  async updateVehicle(vehicleId, vehicleData) {
    return this.makeRequest(`/api/admin/vehicle/${vehicleId}/update`, {
      method: 'PUT',
      body: JSON.stringify(vehicleData),
    });
  }

  // ✅ Allocate vehicle to student
  async allocateVehicle(allocationData) {
    return this.makeRequest('/api/admin/vehicle/allocate', {
      method: 'POST',
      body: JSON.stringify(allocationData),
    });
  }

  // ✅ Get student's vehicle allocation
  async getStudentAllocation(studentId) {
    return this.makeRequest(`/api/admin/vehicle/student/${studentId}/allocation`);
  }

  // ✅ Remove vehicle allocation
  async deallocateVehicle(allocationId) {
    return this.makeRequest(`/api/admin/vehicle/allocation/${allocationId}/deallocate`, {
      method: 'POST',
    });
  }
  // ✅ List all vehicle allocations
  async listAllocations() {
    return this.makeRequest('/api/admin/vehicle/allocation/list');
  }

  // ✅ Update vehicle allocation
  async updateAllocation(allocationId, allocationData) {
    return this.makeRequest(`/api/admin/vehicle/allocation/${allocationId}/update`, {
      method: 'PUT',
      body: JSON.stringify(allocationData),
    });
  }

  // 🔄 Compatibility wrappers for existing code
  async addVehicle(vehicleData) {
    return this.createVehicle(vehicleData);
  }

  async addRoute(vehicleId, routeData) {
    const updateData = {
      route: routeData.routeName,
      pickupPoints: `${routeData.startPoint}, ${routeData.endPoint}`,
      routeDistance: routeData.distance ? parseFloat(routeData.distance) : null,
      routeTime: routeData.estimatedTime || null
    };
    return this.updateVehicle(vehicleId, updateData);
  }

  async assignStudent(allocationData) {
    return this.allocateVehicle(allocationData);
  }

  async addMaintenance(vehicleId, maintenanceData) {
    // Map service fields to updateVehicle
    const vehicleData = {
      lastServiceDate: maintenanceData.date,
      nextServiceDate: maintenanceData.nextDueDate,
    };
    return this.updateVehicle(vehicleId, vehicleData);
  }
}


// ✅ Export single instance
const vehicleService = new VehicleService();
export default vehicleService;
